import React, {useRef, useEffect, useMemo} from 'react';
import {Item as TabItem} from "devextreme-react/tab-panel";
import Form, {GroupItem, SimpleItem, Label, FormRef} from "devextreme-react/form";
import Guid from "../../models/Guid";
import {FormListBase, FormListBaseTab, FormListBaseGrid, FormListBaseToolbar} from '../base';
import useCustomDataSource, {IFormBaseDataSourceOptions, Mode} from "../../hooks/useCustomDataSource";
import useApi from '../../hooks/useApi';

interface IConfigurationServeurCourrielProps {
    isModeSelection?: boolean,
}

interface ConfigurationServeurCourriel {
    OUTLOOK: boolean,
    SERVEUR_SMTP: string,
    SERVEUR_SMTP_PORT: string,
    SERVEUR_SMTP_SSL: boolean,
    SERVEUR_SMTP_USER: string,
    SERVEUR_SMTP_PASS: string
}

export default function ConfigurationServeurCourriel({isModeSelection}: IConfigurationServeurCourrielProps) {
    const enregistrementFormDataSource = useCustomDataSource<ConfigurationServeurCourriel, ConfigurationServeurCourriel>({path: "enregistrement", primaryKey: "idEnregistrementEntete"});
    const {setMainForm, selectedDataRow: selectedEnregistrement, setIsFieldModifier, setSelectedDataRow, mode, setMode, isFieldModifier, onFieldDataChanged} = enregistrementFormDataSource;
    const formRef = useRef<FormRef>(null);

    const {
        getData: getConfig,
    } = useApi('Configuration');

    useEffect(() => {
        try {
            const names = 'OUTLOOK,SERVEUR_SMTP,SERVEUR_SMTP_PORT,SERVEUR_SMTP_SSL,SERVEUR_SMTP_USER,SERVEUR_SMTP_PASS'
            getConfig({customPath: `Configuration/${names}/Config`})
                .then((result) => {
                    setSelectedDataRow((prev: any) => {
                        if (!result || typeof result !== "object")
                            return prev;
                        return {...prev, ...result}
                    })
                })
                .catch((error) => {
                    // console.log()
                })
        } catch (error) {
        }
    }, [])

    const setDataRow = (e: string) => {
        setSelectedDataRow((prev: ConfigurationServeurCourriel) => (
            {...prev, [e]: Guid.empty.toString()}
        ));
        setIsFieldModifier(true);
    }

  const adresseEditorOptions = useMemo(() => {
    return { width: '90%' }
  }, []);

  const portEditorOptions = useMemo(() => {
    return { width: '50px' }
  }, []);

  const userEditorOptions = useMemo(() => {
    return { width: '40%' };
  }, []);

    useEffect(() => {
        setMainForm(formRef.current?.instance());
    })

    console.log(selectedEnregistrement)
    return (
        <FormListBase data={enregistrementFormDataSource} hideList={true}>
            {/* <FormListBaseGrid dataSource={enregistrementFormDataSource.dataSource} onFocusedRowChanged={() => { setIsModeModify(false) }}      >
        <Column key={"grid-col-idEnregistrementEntete"} dataField={"idEnregistrementEntete"} caption="Description" allowHiding={false} />
      </FormListBaseGrid> */}
            <FormListBaseToolbar removeBlocked={true} headerText={''} sauvegarderOptions={{disabled: !isFieldModifier}} annulerOptions={{disabled: !isFieldModifier}} effacerOptions={{visible: false, disabled: !isFieldModifier}}/>
            {!isModeSelection || isModeSelection && mode !== Mode.Lecture
                ? <FormListBaseTab>
                    <TabItem title="Général">
                        <Form ref={formRef} readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedEnregistrement || {} as ConfigurationServeurCourriel} className={"forms"} labelLocation={"left"} showColonAfterLabel={true} onFieldDataChanged={onFieldDataChanged}>
                            <GroupItem caption={"Serveur de courriel"}>
                                <SimpleItem key={"frm-OUTLOOK"} dataField={"OUTLOOK"} editorType={"dxCheckBox"}>
                                    <Label text="Utiliser Microsoft Outlook pour l'envoi des courriels"/>
                                </SimpleItem>
                                {selectedEnregistrement.OUTLOOK &&
                                    <GroupItem>
                                        <GroupItem colCount={2}>
                                            <SimpleItem key={"frm-SERVEUR_SMTP"} dataField={"SERVEUR_SMTP"} editorOptions={adresseEditorOptions}>
                                                <Label text={"Adresse Serveur SMTP"}/>
                                            </SimpleItem>
                                            <SimpleItem key={"frm-SERVEUR_SMTP_PORT"} dataField={"SERVEUR_SMTP_PORT"} editorOptions={portEditorOptions}>
                                                <Label text="Port"/>
                                            </SimpleItem>
                                        </GroupItem>
                                        <SimpleItem key={"frm-SERVEUR_SMTP_SSL"} dataField={"SERVEUR_SMTP_SSL"} editorType={"dxCheckBox"}>
                                            <Label text="Connexion sécurisée (SSL)"/>
                                        </SimpleItem>
                                        <SimpleItem key={"frm-SERVEUR_SMTP_USER"} dataField={"SERVEUR_SMTP_USER"}>
                                            <Label text={"Utilisateur"}/>
                                        </SimpleItem>
                                        <SimpleItem key={"frm-SERVEUR_SMTP_PASS"} dataField={"SERVEUR_SMTP_PASS"}>
                                            <Label text={"Mot de passe"}/>
                                        </SimpleItem>
                                    </GroupItem>
                                }
                            </GroupItem>
                        </Form>
                    </TabItem>
                </FormListBaseTab> : null}
        </FormListBase>
    );
}